import React, { useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const Slot = ({ superAdmin }) => {
  const [daysList, setDaysList] = useState(["T", "W", "Th", "F", "S", "SU"]);
  const [selectedDay, setSelectedDay] = useState(["Monday"]);
  const [showSchedule, setShowSchedule] = useState(false);
  const [realDay, setRealDay] = useState("Monday");
  const [schedule, setSchedule] = useState([]);

  const handleDayClick = (day) => {
    // console.log('day', day);
    setRealDay(day);
    setSelectedDay([day]);
    setShowSchedule(false);
    setSchedule([]);

    const dayAbbreviation = getDayAbbreviation(day);
    const otherDays = days
      .filter((d) => d !== day)
      .map((d) => getDayAbbreviation(d));

    setDaysList(otherDays);
  };

  const getDayAbbreviation = (day) => {
    switch (day) {
      case "Monday":
        return "M";
      case "Tuesday":
        return "T";
      case "Wednesday":
        return "W";
      case "Thursday":
        return "Th";
      case "Friday":
        return "F";
      case "Saturday":
        return "S";
      case "Sunday":
        return "SU";
      default:
        return day;
    }
  };

  // console.log('daysList', daysList)
  const handleToggle = (day) => {
    setShowSchedule((prev) => !prev);
    let filteredDays = daysList.filter(
      (item) => item !== day.map((item) => item.charAt(0))
    );
    setDaysList(filteredDays);
  };

  // console.log('scheduleDays', schedule)

  const handleSubmit = () => {
    let updatedArray = schedule.map((item) =>
      item == "M"
        ? "Monday"
        : item == "T"
        ? "Tuesday"
        : item == "W"
        ? "Wednesday"
        : item == "Th"
        ? "Thursday"
        : item == "F"
        ? "Friday"
        : item == "S"
        ? "Saturday"
        : "Sunday"
    );
    console.log("updatedArray", updatedArray);
    setSelectedDay([...updatedArray, realDay]);
  };

  console.log(selectedDay, "selectedDay");
  return (
    <div className="dashRightView">
      <div className="slot-container d-flex">
        {/* Days Button */}
        <div className="days-wrapper d-flex ac-jb">
          {days.map((day) => (
            <button
              key={day}
              className={`f2 fs-sm-10 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 day-btn ${
                selectedDay.includes(day) ? "active" : ""
              }`}
              onClick={() => handleDayClick(day)}
            >
              {day}
            </button>
          ))}
        </div>

        {/* Schedule Box */}
        <div className="Oversall-box d-flex ac-jb">
          <div className="d-flex ac-jc gap-3 my-4">
            <h3 className="f3 fs-sm-16 fs-md-18 fs-lg-18 fs-xl-22 fs-xxl-27">
              {realDay} Schedule
            </h3>
            <div
              className="gap-3 d-flex toggle-btn"
              onClick={() => handleToggle(selectedDay)}
              style={{ marginBottom: "35px" }}
            >
              {showSchedule ? (
                <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
              ) : (
                <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
              )}
            </div>
          </div>

          {showSchedule && (
            <div className="schedule-box ">
              <div className="time-inputs">
                <div>
                  <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                    Start Time (mins)
                  </label>
                  <input type="time" disabled={superAdmin} />
                </div>
                <div>
                  <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                    End Time (mins)
                  </label>
                  <input type="time" disabled={superAdmin} />
                </div>
              </div>
              {/* <div className="d-flex as-jb my-3">
                {daysList.map((item, ind) => (
                  <label className="d-flex gap-2" key={ind}>
                    {item}
                    <input
                      type="checkbox"
                      checked={schedule.includes(item)}
                      onChange={() => handleSelect(item)}
                    />

                  </label>
                ))}


              </div> */}
              {!superAdmin && (
                <div className="d-flex as-je ">
                  <button className="submit-btn mt-4" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Slot;
